module.exports = __webpack_public_path__ + "media/components/assets/img/icons/bulb-58ed51ef900262312af45fc3c90da883.svg";